import React, { useState } from "react";
import Button from 'components/shared/Button'
import GetAppIcon from '@material-ui/icons/GetApp';
import { Toast } from "components/shared/Toaster"
import { downloadFileByPayload, printFmcsaReport } from 'actions/applicants'
import strings from "strings";

// The backend prints the report (rox-pdf-printer) from the stored search, with the latest extensive search included,
// attaches it to the application and returns the file.
const FmcsaReport = ({ applicationId, mode }) => {
    const [loading, setLoading] = useState(false)

    const handleDownload = () => {
        if (loading) return
        setLoading(true)
        printFmcsaReport(applicationId)()
            .then((file) => downloadFileByPayload({ applicationId, fileId: file.uuid, fileName: file.fileName })())
            .then(() => Toast({ type: 'success', message: strings.REPORT_SUCCESS_MSG }))
            .catch(() => Toast({ type: 'error', message: strings.SOMETHING_WENT_WRONG }))
            .finally(() => setLoading(false))
    }

    if (mode === 'button') {
        return <Button loading={loading} onClick={handleDownload}>{strings.GENERATE_NEW_REPORT}</Button>
    }
    return <GetAppIcon className='mt-3p ml-3' color={loading ? 'disabled' : 'primary'} onClick={handleDownload}
                       titleAccess={strings.GENERATE_NEW_REPORT} />
}

export default FmcsaReport;
